import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { TermsAndPoliciesPage } from './terms-and-policies.page';

const routes: Routes = [
  {
    path: '',
    component: TermsAndPoliciesPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [TermsAndPoliciesPage],
  exports: [TermsAndPoliciesPage]
})
export class TermsAndPoliciesPageModule {}
